var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-col-12"},[_c('page-header',{attrs:{"title":"dataTable.quick-protocol-create.title","actions":_vm.pageActions}}),_c('ancestryline-data-table',{ref:"quickprotocoldatatable",attrs:{"data-function":_vm.dataFunction,"default-filter":_vm.filters,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }